module.exports = __webpack_public_path__ + "img/mike.60980152.png";